import dayjs from 'dayjs';

import { DateInput } from '../types';

export const toMonthAndYearString = (date: DateInput) => dayjs(date).format('MM/YYYY');
